export const ACTIONS = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  EDIT: 'EDIT',
  SEND: 'SEND',
  VERIFY: 'VERIFY',
  RESEND: 'RESEND',
  SET_AS_DEFAULT: 'SET_AS_DEFAULT'
}

export const SUBJECTS = {
  BANK_ACCOUNT_DETAILS: 'Bank Account Details',
  DEPOSIT: 'Deposit',
  ACCOUNT_PURPOSE: 'Account Purpose'
}
